import React, {useState} from "react";
import {Search, UserCheck, UserPlus, UserX} from "react-feather";
import {MainMenu} from "./MainMenu";
import {Dropdown, Menu} from "antd";
import {useTranslation} from "react-i18next";
import {hasAnyRole, isAdmin, isAuthenticated, permissions, useAuthenticatedUser} from "../../hooks/user";
import {useHistory} from "react-router-dom";
import {useUserMe} from "../../hooks/user";
import {ScrollTop} from "../ScrollTop";
import {SearchCertificates} from "../SearchCertificates";
import {CertificateListItemDto} from "../../generated-api";

export function PageHeader() {
    const {t} = useTranslation();
    const history = useHistory();
    const [sideMenuOpen, setSideMenuOpen] = useState(false);
    const [searchOpen, setSearchOpen] = useState(false);

    const authenticatedUser = useAuthenticatedUser();
    const userMeResponse = useUserMe();
    const userMe = userMeResponse.data || {};

    const logout = () => {
        if (authenticatedUser) {
            authenticatedUser.signOut();
            window.location.reload();
        }
    };

    const userMenu = (
        <Menu>
            {isAuthenticated()
                ? <>
                    <Menu.Item disabled>
                        {userMe.firstName} {userMe.lastName}
                    </Menu.Item>
                    <Menu.Item onClick={() => history.push('/profile')}>
                        {t('menu.profile')}
                    </Menu.Item>
                    <Menu.Item onClick={logout}>
                        {t('menu.logout')}
                    </Menu.Item>
                </>
                :
                <Menu.Item onClick={() => history.push('/login')}>
                    {t('menu.login')}
                </Menu.Item>
            }
        </Menu>
    );

    const canSearch = hasAnyRole(permissions.certificatesSearch);

    return (<>
        <ScrollTop/>
        <header className="header">
            <nav className="navbar">
                <div className={'flex-row'}>
                    <div className={'flex-auto'}>
                        <a className="navbar-brand" href="/" onClick={event => {
                            event.preventDefault();
                            history.push('/dashboard');
                        }}>
                            <img alt="" src={'/ct_logo.png'} className={'header-logo'}/>
                        </a>
                    </div>
                    <div>
                        <Dropdown overlay={userMenu} placement={'bottom'} trigger={['click']}>
                            <div className={'header-icon-button'}>
                                {!isAuthenticated() ? <UserX/> : isAdmin() ? <UserPlus/> : <UserCheck/>}
                            </div>
                        </Dropdown>
                    </div>
                    {!!canSearch && <div>
                      <div className={'header-icon-button' + (searchOpen ? ' active' : '')}>
                        <Search onClick={() => setSearchOpen(!searchOpen)}/>
                      </div>
                    </div>}
                    <div>
                        <div className={'bars' + (sideMenuOpen ? ' active' : '')}
                             onClick={() => setSideMenuOpen(!sideMenuOpen)}/>
                    </div>
                </div>
            </nav>
        </header>
        <div className={'header-placeholder'}/>
        <div className={'sidemenu' + (sideMenuOpen ? ' open' : '')}>
            <div className={'sidemenu-inner'}>
                <MainMenu/>
            </div>
        </div>
        {!!canSearch && <SearchCertificates
          show={searchOpen}
          multiSelect={false}
          addLinksButton={false}
          onClose={() => setSearchOpen(false)}
          onClick={(certificate: CertificateListItemDto) => history.push('/certificates/' + certificate.id)}
        />}
    </>)
}
